module.exports = __webpack_public_path__ + "img/Poorter_hotel-399.731acb2d.jpg";